@if (banner && source === 'quotes') {
<app-exclusive-tag [type]="'tag'" [placement]="exclusiveTabPlacements?.QuotesTag" [exclusive]="banner"
  [quote]="selectedQuote"></app-exclusive-tag>

<app-exclusive-tag [type]="'tag'" [placement]="exclusiveTabPlacements?.EvTariff2" [exclusive]="banner"
  [quote]="selectedQuote"></app-exclusive-tag>
}
<div [ngClass]="source === 'quotes' ? 'boxTyp13 mb-4' : ''">
  <!-- <div class="top-left-banner mx-4 mt-2">
  <app-exclusive-tag [type]="'infoBar'" [placement]="exclusiveTabPlacements?.EvTariff" [exclusive]="banner"
    [quote]="selectedQuote"></app-exclusive-tag>
  </div> -->
  <div class="d-grid d-lg-flex">
    <div class="d-flex flex-column" [ngClass]="source === 'quotes' ? 'w-lg-45' : 'w-lg-55'">
      <div class="d-flex gap-2">
        <!-- Supplier Logo 25-->
        <div class="text-center w-25" [ngClass]="(source === 'quotes' || !isSmallScreen) ? 'py-4' : 'pb-4'">
          <img [src]="selectedQuote?.SupplierLogo" alt="Supplier Logo"
            class="w-75 supplier-logo sessioncamexclude sessioncamhidetext maskpii" />
        </div>
        <!-- Supplier Details 75-->
        <div class="w-75" [ngClass]="(source === 'quotes' || !isSmallScreen) ? 'py-4' : 'pb-4'">
          <h4 [id]="id?.quote + '_SupplierName'" class="m-0 fs-17 fw700 sessioncamexclude sessioncamhidetext maskpii">
            {{ selectedQuote?.SupplierName }}
          </h4>
          <p [id]="id?.quote + '_TariffName'" class="m-0 pe-1 fs-17 fw400 sessioncamexclude sessioncamhidetext maskpii">
            {{ selectedQuote?.TariffName }}</p>
        </div>
      </div>
      <div class="d-flex gap-2 px-4" [ngClass]="source === 'quotes' ? '' : 'justify-content-center'">
        @if (source === 'quotes') {
        <!-- Supplier Ratings -->
        <!-- <div class="w-25 pb-2 text-center lh-1">
        </div> -->
        }
        <!-- Energy Details -->
        <div class="w-100 pb-2 lh-1">
          <div class="bg-col45 r-16 text-center p-4 mb-4" [ngClass]="source === 'quotes' ? '' : ''">
            <p class="m-0 fs-20">Estimated monthly cost</p>

            <!-- New EV design -->
            @if (!!selectedQuote?.isEVTariff && !!selectedQuote?.Fuels?.Electricity?.EVCalculationData) {

            <span class="fs-30 fw700 sessioncamexclude sessioncamhidetext maskpii">&pound;{{
              selectedQuote?.Fuels?.Electricity?.EVCalculationData?.totalCostMonthly |
              number: '1.0-2' }} </span>
            <p class="m-0 fs-17 mb-3">Price includes VAT</p>
            <hr>

            <div class="mt-2 d-flex justify-content-between">
              <p class="m-0 fs-17">Home cost</p>
              <p class="m-0 fs-17 sessioncamexclude sessioncamhidetext maskpii">
                &pound;{{ selectedQuote?.Fuels?.Electricity?.EVCalculationData?.homeCostPoundsMonthly |
                number: '1.0-2' }}
              </p>
            </div>
            <div class="mt-2 d-flex justify-content-between">
              <p class="m-0 fs-17">EV cost</p>
              <p class="m-0 fs-17 sessioncamexclude sessioncamhidetext maskpii">
                &pound;{{ selectedQuote?.Fuels?.Electricity?.EVCalculationData?.totalEvCostAtHomePoundsMonthly |
                number: '1.0-2' }}
              </p>
            </div>

            <hr>

            <div class="mt-2 d-flex justify-content-between">
              <p class="m-0 fs-17">Standard Rate</p>
              <p class="m-0 fs-17 sessioncamexclude sessioncamhidetext maskpii">
                {{ selectedQuote?.Fuels?.Electricity?.UnitRate | perUnit }}
              </p>
            </div>
            <div class="mt-2 d-flex justify-content-between">
              <p class="m-0 fs-17">Off-peak rate</p>
              <p class="m-0 fs-17 sessioncamexclude sessioncamhidetext maskpii">
                {{ selectedQuote?.Fuels?.Electricity?.NightUnitRate | perUnit }}
              </p>
            </div>

            <!-- <div class="my-2 d-flex justify-content-between">
              <p class="m-0 fs-17">Total</p>
              <p class="m-0 fs-20 fw700 sessioncamexclude sessioncamhidetext maskpii">
                &pound;{{ selectedQuote?.Fuels?.Electricity?.EVCalculationData?.totalCostMonthly |
                number: '1.0-2' }}
              </p>
            </div> -->
            } @else {
            <!-- Normal tariff -->
            <span class="fs-30 fw700 sessioncamexclude sessioncamhidetext maskpii">&pound;{{
              selectedQuote?.EstimatedMonthlyCost | number: '1.0-2' }}</span>
            <p class="m-0 fs-17 mb-3">Price includes VAT</p>
            }
            <hr>

            @if (isNegNumber(selectedQuote?.SavingPerYear)) {
            <!-- Cost increased -->
            <p class="m-0 fs-17">
              Opting for this plan would result in a cost increase of &pound;<span
                class="sessioncamexclude sessioncamhidetext maskpii">{{ savingPerMonth() }}</span>
              compared to your current tariff.
            </p>
            } @else {
            <!-- Cost saving -->
            <p class="m-0 fs-17">Switching to this plan would save you &pound;<span
                class="sessioncamexclude sessioncamhidetext maskpii">{{ savingPerMonth() }}</span> per
              month compared to your current tariff.</p>
            }
          </div>
          <p class="m-0 fs-17">
            Estimated annual cost: <span class="fw700 sessioncamexclude sessioncamhidetext maskpii">
              &pound;{{ selectedQuote?.EstimatedYearlyCost | number: '1.0-2' }}
            </span>
          </p>
          @if (!!selectedQuote?.isEVTariff && !!selectedQuote?.Fuels?.Electricity?.EVCalculationData) {
          <div class="pt-1">
            <button [id]="id?.quote + '_HowWasMyHomeAndEVCalculated'"
              class="btn btn-secondary-link ps-0 fs-17 withWrap text-start" (click)="openSimplePopup()">
              Home & EV Charges Explained
            </button>
          </div>
          }
        </div>
      </div>
    </div>
    <!-- Tariff Details -->
    <div class="d-flex flex-column" [ngClass]="source === 'quotes' ? 'w-lg-55' : 'w-lg-45'">
      <div class="mt-2 mt-lg-0 py-lg-4"
        [ngClass]="source === 'quotes' && !isSmallScreen ? 'border-start px-3' : 'ps-3'">
        <div class="d-flex align-items-center align-items-lg-start justify-content-between"
          [ngClass]="source !== 'quotes' && !isSmallScreen ? 'mb-5' : ''">
          @if (source === 'quotes') {
          <h4 class="m-0 fs-17 fw700">Tariff details</h4>
          @if (banner) {
          <app-exclusive-tag [type]="'infoBar'" [placement]="exclusiveTabPlacements?.PeakSaveSunday"
            [exclusive]="banner" [quote]="selectedQuote"></app-exclusive-tag>
          }
          } @else if (!isSmallScreen) {
          <img id="EnergyComparison_YourTariffs_TariffInformation_CloseIcon" src="./assets/ctm-images/close.svg"
            alt="close" class="cy-closeIcon position-absolute end-0 me-4" (click)="closeDialog()">
          }
        </div>
      </div>
      <div class="mt-3 mt-lg-0 mb-2 mb-lg-0 h-100"
        [ngClass]="source === 'quotes' && !isSmallScreen ? 'border-start px-4' : 'ps-4'">
        <div class=" bg-col27 rounded-4 px-4 py-2 mb-md-3 mb-lg-0">
          <div class="d-flex flex-column">
            <!-- Contract/Tariff Type -->
            <div class="d-flex fs-17 py-2 gap-2 justify-content-between justify-content-lg-start">
              <p class="m-0 min-w-40p">Contract type</p>
              <div>
                <p class="m-0 fw700 sessioncamexclude sessioncamhidetext maskpii">
                  {{ getContractDetails(selectedQuote)}}
                </p>
                @if (banner) {
                <app-exclusive-tag [type]="'toolTip'" [placement]="exclusiveTabPlacements?.ContractInfo"
                  [exclusive]="banner" [quote]="selectedQuote"></app-exclusive-tag>
                }
              </div>
            </div>
            <div class="seprator8"></div>
            <!-- Total exit fee -->
            <div class="d-flex fs-17 py-2 gap-2 justify-content-between justify-content-lg-start">
              <p class="m-0 min-w-40p">Total exit fee</p>
              <p class="m-0 fw700 sessioncamexclude sessioncamhidetext maskpii">
                &pound;{{ selectedQuote?.EarlyExitFee | number: '1.0-2' }}
              </p>
            </div>
            <div class="seprator8"></div>
            <!-- Green Tariff -->
            <div class="d-flex fs-17 py-2 gap-2 justify-content-between justify-content-lg-start">
              <p class="m-0 min-w-40p">Green tariff</p>
              <p class="m-0 fw700 sessioncamexclude sessioncamhidetext maskpii">
                {{ selectedQuote?.IsRenewable === 1 ? 'Yes' : 'No' }}
              </p>
            </div>
            <div class="seprator8"></div>
            <!-- Payment method -->
            <div class="d-flex fs-17 py-2 gap-2 justify-content-between justify-content-lg-start">
              <p class="m-0 min-w-40p">Payment method</p>
              <p class="m-0 fw700 sessioncamexclude sessioncamhidetext maskpii">
                {{ selectedQuote?.PaymentMethodText }}
              </p>
            </div>
            @if (selectedQuote?.offPeakRate?.StartTime && source !== 'quotes') {
            <div class="seprator8"></div>
            <!-- Off peak charging timing -->
            <div class="d-flex fs-17 py-2 gap-2 justify-content-between justify-content-lg-start">
              <p class="m-0 min-w-40p">Off peak timing</p>
              <p class="m-0 fw700 sessioncamexclude sessioncamhidetext maskpii">
                ({{ selectedQuote?.offPeakRate?.StartTime }} - {{ selectedQuote?.offPeakRate?.EndTime }})
              </p>
            </div>
            }
          </div>
        </div>
        @if (banner) {
        <!-- App Info -->
        <app-exclusive-tag [type]="'appInfo'" [placement]="exclusiveTabPlacements?.InfoBar" [exclusive]="banner"
          [quote]="selectedQuote"></app-exclusive-tag>
        }

        <!-- Promotional message -->
        @if (selectedQuote?.promotion) {
        <div class="pt-lg-4 pt-3">
          <div class="alert-banner d-flex align-items-center">
            <img src="../../../../assets/ctm-images/pricetag.svg" />
            <p class="mb-0">
              Free boiler cover for 12 months if you purchase
              before August 9th, 2023
            </p>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
  @if (source === 'quotes') {
  <div class="d-grid d-lg-flex justify-content-lg-between align-items-lg-center border-top p-4">
    <div class="d-grid mt-3 mt-lg-0">
      <!-- CTM Rewards -->
      <app-exclusive-tag [type]="'ctmRewards'" [placement]="exclusiveTabPlacements?.CTMRewards" [exclusive]="banner"
        [quote]="selectedQuote"></app-exclusive-tag>
      <!-- Supplier Rewards -->
      <app-exclusive-tag [type]="'supplierRewards'" [placement]="exclusiveTabPlacements?.SupplierRewards"
        [exclusive]="banner" [quote]="selectedQuote"></app-exclusive-tag>
    </div>
    <!-- Tariff CTAs -->
    <div class="w-lg-45 order-1 order-lg-2">
      <div class="d-grid d-lg-flex justify-content-lg-end p-2 w-100 gap-3 mb-md-3 mb-lg-0">
        <button [id]="id?.quote + '_TariffsYouCanSwitch_TariffDetails'" class="cy-quotes btn btn-primary-outline mb-0"
          (click)="eventTrigger('openTariff')">
          Tariff details
        </button>
        @if (selectedQuote?.isSwitchable) {
        <button [id]="getSwitchNowId()" class="cy-switchNow btn btn-primary mb-0"
          (click)="!isLoading ? eventTrigger('switchNow') : ''" [ngClass]="isLoading ? 'animate' : ''"
          [disabled]="isLoading">
          <span class="spinner"></span>
          <span class="text">
            {{ selectedQuote?.isRetention ? 'Fix rate' : 'Switch now'}}
          </span>
        </button>
        } @else {
        <span class="d-lg-inline-flex align-items-center d-block text-center mb-2">Contact the supplier</span>
        }
      </div>
    </div>
  </div>
  } @else {
  <div class="d-grid d-lg-flex justify-content-lg-between align-items-lg-center border-top p-4">
    <div class="d-grid mt-3 mt-lg-0">
      <!-- Supplier Rewards -->
      <app-exclusive-tag [type]="'supplierRewards'" [placement]="exclusiveTabPlacements?.SupplierRewards"
        [exclusive]="banner" [quote]="selectedQuote"></app-exclusive-tag>
    </div>
  </div>
  }
</div>